import { compareVersions } from 'compare-versions'
import { getMobileAppVersion } from './mobile'

// Notifications are enabled in versions >= 1.0.57
const ENABLED_VERSION = '1.0.57'

export const isNotificationsEnabled = () => {
  const appVersion = getMobileAppVersion()
  if (appVersion) {
    return compareVersions(appVersion, ENABLED_VERSION) >= 0
  }

  return true
}
